<script lang="ts">
    import CreatureComponent from "./Creature.svelte";
    import { Encounter } from "./encounters";

    export let encounter: Encounter;

    $: creatureCounts = encounter.getCreatureCounts();
    $: creatures = encounter.getUniqueCreatures();
</script>

<div>
    <h2>{encounter.danger}</h2>
    <h3>Difficulty {encounter.difficulty}</h3>
    <p style="font-weight:bold" title="See p. 189/190 in SotDL Core Rules">
        Recommended Difficulty: {encounter.recommendedDifficulty.min} - {encounter
            .recommendedDifficulty.max > 0
            ? encounter.recommendedDifficulty.max
            : "no max"}
    </p>
    <table>
        <th>Amount</th>
        <th>Creature</th>
        {#each creatures as creature}
            <tr>
                <td><h1>{creatureCounts[creature.name]}</h1></td>
                <td><CreatureComponent {creature} /></td>
            </tr>
        {/each}
    </table>
</div>

<style>
    div {
        margin: 4px;
    }
    table {
        border-collapse: collapse;
    }
    th {
        background-color: #000;
        color: #fff;
        text-align: center;
        padding: 4px;
        padding-left: 8px;
    }
    td {
        text-align: center;
    }
    tr:nth-child(2n) {
        background-color: #fff;
    }
</style>
